/**
 * Scripts for sticky header
 * Only runs on landing pages
 */

// Only run on landing pages
if (document.body.classList.contains('page-template-landing-page')) {
const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
	const logo = document.querySelector('.logo-wrapper .logo');

	// Function to switch logo color
	function switchLogo(useDarkLogo) {
		if (!logo) return;
		
		if (useDarkLogo) {
			logo.src = logo.getAttribute('data-logo-dark');
		} else {
			logo.src = logo.getAttribute('data-logo-white');
		}
	}

let lastScroll = 120;
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 120) {
    body.classList.remove(scrollUp);
    body.classList.remove(scrollDown);
			// Use white logo when at top
			switchLogo(false);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
			// Use dark logo when scrolling
			switchLogo(true);
  } 
  else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
			// Use dark logo when scrolling
			switchLogo(true);
  }
  lastScroll = currentScroll;
});
}
